export default __webpack_public_path__ + "static/media/LogoRoundless.d5dc259d.png";